import { EExamTab } from '../enums'
import { IOptionItem } from 'interfaces'

export const C_EXAM_TABS: Array<IOptionItem> = [
  { label: 'medical-record', value: EExamTab.MedicalRecord },
  { label: 'directed', value: EExamTab.Directed },
  {
    label: 'prescription',
    value: EExamTab.Prescription
  },
  {
    label: 'subclinical-and-history',
    value: EExamTab.SubclinicalAndHistory
  },
  {
    label: 'exam-history',
    value: EExamTab.ExamHistory
  }
]
export const C_PATIENT_DETAIL_TABS: Array<IOptionItem> = [
  { label: 'vital', value: EExamTab.MedicalRecord },
  {
    label: 'pathological-process',
    value: EExamTab.PathologicalProcess
  },
  {
    label: 'exam-history',
    value: EExamTab.ExamHistory
  }
]
